const firebaseConfig = {
    apiKey: "AIzaSyAAe43qrBwZ_m-vynhx7ittRgiOHyhVRfk",
    authDomain: "charchas.firebaseapp.com",
    projectId: "charchas",
    storageBucket: "charchas.appspot.com",
    messagingSenderId: "959267204319",
    appId: "1:959267204319:web:d91be37ba73131a7e2cd6a"
};

export default firebaseConfig;
